export var source_tab = { "uid": "source_tab", "fields": { "title": { "defaultValue": "" }, "tab_title": { "defaultValue": "" } } };
